import {
  GroupDTO,
  GroupService as BaseGroupService
} from 'react-angle-dashboard-components'

import { Group, CreateGroupDTO, UserInfo } from '../../interfaces/group'

const mapGroupToDTO = (data: Group): CreateGroupDTO => ({
  zip: String(data.zip),
  token: data.token || undefined
})

export class GroupService extends BaseGroupService {
  modify(data: Partial<GroupDTO>) {
    return this.modifyGroup(data)
  }

  async sendLoginEmail() {
    return this.request({
      method: 'post',
      url: '/email/login',
      credentials: true
    })
  }

  async create(data: Group): Promise<UserInfo> {
    return this.request({
      method: 'post',
      url: '/groups',
      data: mapGroupToDTO(data),
      credentials: false
    })
  }
}
